import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { authHeader } from "../../utils/authHeader";
import "./profileRightBar.scss";

import { API_BASE_URL } from "../../config";

/**
 * Tarjeta "Información" de la columna izquierda del perfil.
 *
 * Recibe por props la persona cuyo perfil se está viendo (`user`). Antes
 * siempre pedía `/api/users/<id de la sesión>`, así que al entrar al perfil
 * de un compañero seguía mostrando tus propios datos. Si no llega el prop
 * (uso antiguo del componente), cae a la ficha de la sesión.
 *
 * Ya NO repite la foto ni el nombre: ambos viven en la cabecera del perfil.
 * Antes se veían tres veces en la misma pantalla (cabecera, título de esta
 * tarjeta y ficha interior).
 */
const ProfileRightBar = ({ user: usuarioVisitado }) => {
  const { currentUser } = useContext(AuthContext);
  const [propio, setPropio] = useState(null);

  useEffect(() => {
    if (usuarioVisitado || !currentUser?.id) return;

    let cancelado = false;
    fetch(`${API_BASE_URL}/api/users/${currentUser.id}`, {
      headers: { ...authHeader() },
    })
      .then((r) =>
        r.ok ? r.json() : Promise.reject(new Error("Error al obtener datos del usuario"))
      )
      .then((datos) => {
        if (!cancelado) setPropio(datos);
      })
      .catch(console.error);

    return () => {
      cancelado = true;
    };
  }, [usuarioVisitado, currentUser?.id]);

  const user = usuarioVisitado || propio || currentUser;
  if (!user) return null;

  const esPropioPerfil = String(user.id) === String(currentUser?.id);
  const esAdmin = currentUser?.rol === "admin";

  // Solo se pintan los datos que realmente llegan: el perfil público de un
  // compañero no incluye teléfono ni datos personales, y no tiene sentido
  // mostrar una fila con un guion por cada campo ausente.
  const filas = [
    { etiqueta: "Cargo", valor: user.cargo },
    { etiqueta: "Área", valor: user.area },
    { etiqueta: "Sede", valor: user.direccionLaboral },
    { etiqueta: "País", valor: user.country },
    { etiqueta: "Correo", valor: user.email },
    { etiqueta: "Teléfono", valor: user.phone },
  ].filter((f) => f.valor);

  return (
    <section className="profileRightBar">
      {/* El distintivo de rol vive ahora en la cabecera del perfil, junto al
          nombre, y solo lo lleva el administrador: repetirlo aquí etiquetaba
          a cada colaborador con un "EMPLEADO" que no aporta nada. */}
      <div className="profileRightBarHeading">
        <h2 className="profileRightBarTitle">Información</h2>
      </div>

      {filas.length > 0 ? (
        <dl className="userDetails">
          {filas.map((f) => (
            <div className="userDetailRow" key={f.etiqueta}>
              <dt>{f.etiqueta}</dt>
              <dd>{f.valor}</dd>
            </div>
          ))}
        </dl>
      ) : (
        <p className="userDetailsEmpty">
          Todavía no hay información laboral registrada.
        </p>
      )}

      {/* "Editar perfil" vive en la cabecera del perfil, junto al nombre,
          como en Facebook. Aquí solo queda el acceso al panel de admin:
          antes el mismo botón salía dos veces en la misma pantalla. */}
      {esPropioPerfil && esAdmin && (
        <div className="actionButtons">
          <Link to="/admin" className="adminButton">
            Panel admin
          </Link>
        </div>
      )}
    </section>
  );
};

export default ProfileRightBar;
